import React, { useState } from "react";
import { L as Link, useLocaleNavigate } from "../lib/i18n";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LanguageContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";

export default function Login() {
  const { login, error } = useAuth();
  const { t } = useLang();
  const navigate = useLocaleNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) navigate("/");
  };

  return (
    <div className="mx-auto flex min-h-[80vh] max-w-md items-center px-4">
      <Card className="w-full border-zinc-800 bg-zinc-950 p-8 text-white">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-red-500">{t.nav.login}</p>
        <h1 className="mt-2 font-display text-3xl font-bold">{t.auth.loginTitle}</h1>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-400">{t.auth.email}</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 border-zinc-800 bg-black text-white" data-testid="login-email" />
          </div>
          <div>
            <div className="flex items-baseline justify-between">
              <Label className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-400">{t.auth.password}</Label>
              <Link to="/forgot-password" className="text-xs text-zinc-400 hover:text-red-500" data-testid="forgot-password-link">{t.auth.forgotPassword}</Link>
            </div>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 border-zinc-800 bg-black text-white" data-testid="login-password" />
          </div>
          {error && <p className="text-sm text-red-500" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={busy} className="w-full bg-red-600 text-white hover:bg-red-500" data-testid="login-submit">
            {busy ? "..." : t.auth.login}
          </Button>
        </form>
        <p className="mt-6 text-sm text-zinc-400">
          {t.auth.noAccount} <Link to="/register" className="text-red-500 hover:underline">{t.auth.register}</Link>
        </p>
      </Card>
    </div>
  );
}
